import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Row,
  Col,
  Spin,
  Image,
  message,
  Select,
  Tooltip
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  DragOutlined
} from "@ant-design/icons";
import './ourTeam.scss'
import UserIcon from "../../../../../../assets/images/icons/userLogo.svg";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../../../../store";
import { useTab } from "../../../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../../../utils";
import linkedin from "../../../../../../assets/images/linkedIn.svg";
import mail from "../../../../../../assets/images/mail.svg";
import ReactPlayer from "react-player/youtube";
import SynthesiaVideo from "../../SynthesiaVideo";
import { DndContext } from "@dnd-kit/core";
import SortableItem from "./SortableItemWrapper";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { putRequest } from "../../../../../../api/http";
import userServiceApi from "../../../../../../api/userServiceApi";

const { TextArea } = Input;
const MAX_CHARACTERS = 500;

export default function OurTeamComponent({
  dataLoader,
  form,
  activeKey,
  whichTab
}) {
  const { state } = useLocation();
  const tabKey = state;
  const subTab = tabKey?.split('/')[1]
  const { tabData } = useStore();
  const tabConfigId = localStorage.getItem("selectedTabId");
  const { micrositeId } = useParams();
  const { deleteSingleItem, postLoader } = useTab();
  const { updateAccreditationImage, updateImage } = useConnectsuForm();

  const [loader, setLoader] = useState(true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();

  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  if (activeKey === "ABOUT_US") {
    localStorage.setItem("tab", activeKey);
  }

  useEffect(() => {
    setFormChanged(false);
    setCanAddNew(true);
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;
    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);

  const renderMedia = (dataItem) => {
    const commonStyles = {
      width: "350px",
      height: "250px",
      display: "flex",
      justifyContent: "center",
    };

    const mediaType = dataItem?.mediaLink?.mediaType;
    const mediaUrl =
      dataItem?.mediaLink?.url || // 👈 form state
      dataItem?.aboutUsTeamDataOutPut?.image?.url; // 👈 backend fallback

    if (!mediaUrl) return null;

    if (mediaType === "SOCIAL_MEDIA") {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={mediaUrl}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (mediaType === "VIMEO_MEDIA") {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <iframe
            src={mediaUrl}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            style={{ width: "100%", height: "100%", backgroundColor: "black" }}
          />
        </div>
      );
    } else if (mediaType === "IMAGE" || !mediaType) {
      // default/fallback: IMAGE or no type provided
      return (
        <div className="iframe-comp" style={commonStyles}>
          <img
            src={mediaUrl}
            alt="media"
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }
    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }


    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };

  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
  };

  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];

    // Check if any unsaved row already has data filled
    const unsavedItem = currentList.find((item) => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.awardsLogos?.url ||
        item?.awardsLogos?.name ||
        item?.bio?.trim() ||
        item?.linkedin?.trim() ||
        item?.email?.trim() ||
        item?.mediaLink?.trim() ||
        item?.media;
      return !item?.id && hasData;
    });

    if (unsavedItem) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    // ✅ Prepend new empty row at the top
    const newList = [
      {
        title: "",
        description: "",
        awardsLogos: null,
        bio: "",
        linkedin: "",
        email: "",
        mediaLink: { mediaType: undefined, url: "" },
        media: null,
      },
      ...currentList,
    ];

    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);

    // Scroll to top to focus on the newly added row
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSave = () => {
    form.submit();

    // After submit succeeds, unlock adding new items
    setTimeout(() => {
      setCanAddNew(true);
      setHasUnsavedItem(false);
    }, 500);
  };

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item =>
      !item?.id &&
      (item?.title?.trim() || item?.description?.trim() || item?.mediaLink?.trim() || item?.media?.trim() || item?.awardsLogos?.url)
    );
    setCanAddNew(!unsavedItem);
  };

  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];

    // Reset unsaved row(s)
    const updatedList = currentList.map(item =>
      !item?.id ? { title: "", description: "", awardsLogos: { name: "", url: "" } } : item
    );

    form.setFieldsValue({ [whichTab]: updatedList });

    // Unlock if no unsaved items
    const unsavedItem = updatedList.find(item =>
      !item?.id &&
      (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
    );

    setCanAddNew(!unsavedItem);

    // refreshUnsavedState()
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.OUR_TEAM?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);
    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.OUR_TEAM]);

  const handleDelete = (whichTab, form, i, name, remove) => {
    const item = form.getFieldValue(whichTab)?.[i];
    const id = item?.id;

    if (id) {
      // Backend delete
      deleteSingleItem(whichTab, id, form);
    } else {
      // UI-only delete (new row not yet saved)
      remove(name);
      setHasUnsavedItem(false);
      refreshUnsavedState();
    }

    // Optional state updates (only if you need them)
    setTimeout(() => {
      const currentList = form.getFieldValue(whichTab) || [];
      const unsavedItem = currentList.find(
        (it) =>
          !it?.id &&
          (it?.title?.trim() || it?.description?.trim() || it?.awardsLogos?.url)
      );

      setCanAddNew(!unsavedItem);
      setHasUnsavedItem(!!unsavedItem);
      refreshUnsavedState();
    }, 100);
  };

  useEffect(() => {
    form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [tabData[whichTab]]);


  const reArrangeOrder = async (payload) => {

    const response = await putRequest(
      userServiceApi.reArrangeDataInAboutUs({
        tabConfigId,
        micrositeId,
        aboutUsEnum: 'OUR_CLIENT',
      }),
      payload
    )
    if (response?.length) {
      message.success('Re-arranged successfully')
    }
  }

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {

    return (
      <div>
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey.split("/")[1] === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <Form.List
                  name={whichTab}
                  initialValue={
                    tabData &&
                      tabData[whichTab] &&
                      tabData[whichTab].length > 0
                      ? tabData[whichTab].map((ele) => {
                        return {
                          id: ele.id,
                          bio: ele.aboutUsTeamDataOutPut.bio,
                          linkedin: ele.aboutUsTeamDataOutPut.linkedin,
                          email: ele.aboutUsTeamDataOutPut.email,
                          mediaLink: ele.aboutUsTeamDataOutPut.image,
                          title: ele.title,
                        };
                      })
                      : [{}]
                  }
                >
                  {(fields, { add, remove, move }) => {
                    const handleDragEnd = ({ active, over }) => {
                      if (!over || active.id === over.id) return;

                      const oldIndex = fields.findIndex(f => f.key === active.id);
                      const newIndex = fields.findIndex(f => f.key === over.id);

                      move(oldIndex, newIndex);
                      const payload = {}
                      form.getFieldValue(whichTab)?.forEach((e, index) => {
                        payload[e?.id] = index
                      })
                      reArrangeOrder(payload)
                    };
                    return (
                      <>
                        <div className="inputBody">
                          <div style={{ textAlign: "right" }}>
                            {hasUnsavedItem && (
                              <Button
                                className="cancelBtn"
                                type="button"
                                // disabled={!formChanged}   // Only enable if editing started
                                onClick={handleClear}
                              >
                                Clear
                              </Button>
                            )}

                            <Button
                              className="greenBtn"
                              onClick={handleAddMore}
                            >
                              Add <PlusOutlined />
                            </Button>
                          </div>
                        </div>
                        <DndContext onDragEnd={handleDragEnd}>
                          <SortableContext items={fields.map(f => f.key)} strategy={verticalListSortingStrategy}>
                            {fields.map(({ key, name, ...restField }, i) => {
                              const formItem =
                                tabData[whichTab] && tabData[whichTab][i];
                              const backendItem =
                                tabData[whichTab] && tabData[whichTab]?.[i];
                              const hasTitle =
                                (formItem?.title &&
                                  formItem?.title?.trim() !== "") ||
                                (backendItem &&
                                  backendItem?.title &&
                                  backendItem?.title.trim() !== "");
                              const hasId = backendItem && backendItem?.id;

                              return (
                                <SortableItem key={key} id={key}>
                                  {({ setNodeRef, attributes, listeners, style }) => (
                                    <div
                                      ref={setNodeRef}
                                      style={style}
                                      className={`d-flex ${subTab === 'OUR_CLIENT' ? 'dnd-wrapper' : ''}`}
                                    >

                                      {subTab === 'OUR_CLIENT' && <div
                                        {...attributes}
                                        {...listeners}
                                        className="drag-handle"
                                      >
                                        <DragOutlined />
                                      </div>}
                                      <div className="card-item">
                                        <Col
                                          className="gutter-row tabContent"
                                          span={16}
                                          style={{ paddingRight: "25px" }}
                                        >
                                          <div style={{ display: "flex" }}>
                                            <Form.Item
                                              className="w-100"
                                              {...restField}
                                              label="Name/Title"
                                              name={[name, "title"]}
                                              labelCol={{ span: 5 }}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Title is required",
                                                },
                                              ]}
                                            >
                                              <Input
                                                placeholder="Enter Title"
                                                maxLength={40}
                                                showCount={{
                                                  formatter: ({ count }) => `${count}/40`,
                                                }}
                                                onKeyDown={(e) => {
                                                  const currentValue = form.getFieldValue([whichTab, name, "title"]) || "";

                                                  // Ignore control keys
                                                  if (
                                                    e.key.length === 1 && // only normal characters
                                                    currentValue.length >= 40
                                                  ) {
                                                    form.setFields([
                                                      {
                                                        name: [whichTab, name, "title"],
                                                        errors: ["Title cannot exceed 40 characters"],
                                                      },
                                                    ]);
                                                  }
                                                }}
                                                onBlur={() => {
                                                  form.setFields([
                                                    {
                                                      name: [whichTab, name, "title"],
                                                      errors: [],
                                                    },
                                                  ]);
                                                }}
                                              />
                                            </Form.Item>

                                            <div
                                              className="remove-btn"
                                              style={{ position: "relative" }}
                                            >
                                              <DeleteOutlined
                                                style={{ cursor: "pointer" }}
                                                title="Delete Team"
                                                onClick={() => {
                                                  handleDelete(
                                                    whichTab,
                                                    form,
                                                    i,
                                                    name,
                                                    remove
                                                  ); // ✅ pass remove too
                                                }}
                                              />
                                            </div>
                                          </div>

                                          <div style={{ display: "flex" }}>
                                            <Form.Item
                                              className="w-100"
                                              label="Description"
                                              {...restField}
                                              labelCol={{ span: 5 }}
                                              name={[name, "bio"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Bio is required",
                                                },
                                                {
                                                  max: MAX_CHARACTERS - 1,
                                                  message: `Description should be less than ${MAX_CHARACTERS} character`,
                                                },
                                              ]}
                                            >
                                              <TextArea
                                                placeholder="Enter Bio Description"
                                                rows={5}
                                                maxLength={MAX_CHARACTERS}
                                                showCount
                                              />
                                            </Form.Item>
                                          </div>
                                          <Form.Item
                                            label={
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {tabKey.split("/")[1] ===
                                                  "OUR_CLIENT" ? 'Website' : (
                                                  <>
                                                    <div style={{ minWidth: '24px', textAlign: "center" }}>
                                                      <img src={linkedin} alt="Image" style={{ marginRight: "3px", maxWidth: '18px' }} />
                                                    </div>
                                                    Linkedin
                                                  </>
                                                )}

                                              </div>
                                            }
                                            labelCol={{ span: 5 }}
                                            {...restField}
                                            name={[name, "linkedin"]}
                                            className={tabKey.split("/")[1] ===
                                              "OUR_CLIENT" ? '' : "iconMoveLeft"}
                                          >
                                            <Input placeholder={tabKey.split("/")[1] ===
                                              "OUR_CLIENT" ? 'Website' : "Linkedin"} />
                                          </Form.Item>

                                          {tabKey.split("/")[1] ===
                                            "OUR_CLIENT" ? null : (
                                            <Form.Item
                                              label={
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <div style={{ minWidth: "24px", textAlign: "center" }}>
                                                    <img
                                                      src={mail}
                                                      alt="Image"
                                                      style={{ marginRight: "3px", maxWidth: '18px' }}
                                                    />
                                                  </div>
                                                  Email
                                                </div>
                                              }
                                              labelCol={{ span: 5 }}
                                              {...restField}
                                              name={[name, "email"]}
                                              rules={[
                                                {
                                                  type: "email",
                                                  message: "Enter valid email",
                                                },
                                              ]}
                                              className="iconMoveLeft"
                                            >
                                              <Input placeholder="Email" />
                                            </Form.Item>
                                          )}

                                          {tabKey.split("/")[1] ===
                                            "OUR_CLIENT" ? (
                                            <>
                                              <div className="d-flex">
                                                <Form.Item
                                                  {...restField}
                                                  className="custom-work"
                                                  name={[name, "mediaLink", "mediaType"]}
                                                  label="Video or Image"
                                                  labelCol={{ span: 5 }}
                                                >
                                                  <Select
                                                    name={[name, "mediaLink", "mediaType"]}
                                                    onChange={(e) =>
                                                      SelectChangeHandler(e, i)
                                                    }
                                                    placeholder="Select Option"
                                                  >
                                                    <Select.Option value="VIMEO_MEDIA">
                                                      Add Vimeo Link
                                                    </Select.Option>
                                                    <Select.Option value="SOCIAL_MEDIA">
                                                      Add Youtube Link
                                                    </Select.Option>
                                                    <Select.Option value="SYNTHESIA_MEDIA">
                                                      Add Synthesia Link
                                                    </Select.Option>

                                                    <Select.Option value="IMAGE">
                                                      Upload Image
                                                    </Select.Option>
                                                  </Select>
                                                </Form.Item>
                                                <Form.Item>
                                                  <div className="remove-btn">
                                                    <Tooltip
                                                      title={
                                                        "Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio"
                                                      }
                                                    >
                                                      <QuestionCircleOutlined />
                                                    </Tooltip>
                                                  </div>
                                                </Form.Item>
                                              </div>
                                              {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                                <Form.Item
                                                  label="Youtube Link"
                                                  labelCol={{ span: 5 }}
                                                  {...restField}
                                                  name={[name, "mediaLink", "url"]}
                                                >
                                                  <Input />
                                                </Form.Item>
                                              ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                                <Form.Item
                                                  label="Vimeo Link"
                                                  labelCol={{ span: 5 }}
                                                  {...restField}
                                                  name={[name, "mediaLink", "url"]}
                                                >
                                                  <Input />
                                                </Form.Item>
                                              ) : findValue(i, "type") === "IMAGE" ? (
                                                <Form.Item
                                                  {...restField}
                                                  label="Image"
                                                  colon={false}
                                                  name="media"
                                                  className="experienceImg uploadedImage"
                                                  labelCol={{ span: 5 }}
                                                >
                                                  {findValue(i, "blob") ? (
                                                    <Image
                                                      src={URL.createObjectURL(
                                                        findValue(i, "blob")
                                                      )}
                                                      alt=""
                                                    />
                                                  ) : findValue(i, "url") ? (
                                                    <Image
                                                      src={findValue(i, "url")}
                                                      alt=""
                                                    />
                                                  ) : (
                                                    <Image src={UserIcon} alt="" />
                                                  )}
                                                  <div>
                                                    <label
                                                      name="file"
                                                      className="fileUploadBtn greenBtn"
                                                    >
                                                      {" "}
                                                      Upload image
                                                      <input
                                                        accept="image/png, image/gif, image/jpeg"
                                                        type="file"
                                                        // required={true}
                                                        onChange={(e) =>
                                                          updateAccreditationImage(e, i, form, whichTab)
                                                        }
                                                      />

                                                    </label>
                                                    <div style={{ marginLeft: '12px', marginTop: '5px' }} className="">Add or Edit</div>
                                                  </div>
                                                </Form.Item>
                                              ) : findValue(i, "type") ===
                                                "SYNTHESIA_MEDIA" ? (
                                                <Form.Item
                                                  label="Synthesia Link"
                                                  labelCol={{ span: 5 }}
                                                  {...restField}
                                                  name={[name, "mediaLink", "url"]}

                                                >
                                                  <Input />
                                                </Form.Item>
                                              ) : null}


                                            </>
                                          ) : (<>
                                            <Form.Item
                                              {...restField}
                                              label="Image"
                                              colon={false}
                                              name="media"
                                              className="experienceImg uploadedImage "
                                              labelCol={{ span: 5 }}
                                            >
                                              {findValue(i, "blob") ? (
                                                <Image
                                                  src={URL.createObjectURL(
                                                    findValue(i, "blob")
                                                  )}
                                                  alt=""
                                                />
                                              ) : findValue(i, "url") ? (
                                                <Image src={findValue(i, "url")} alt="" />
                                              ) : (
                                                <Image src={UserIcon} alt="" />
                                              )}
                                              <div>
                                                <label
                                                  name="file"
                                                  className="fileUploadBtn greenBtn"
                                                >
                                                  {" "}
                                                  Upload image
                                                  <input
                                                    accept="image/png, image/gif, image/jpeg"
                                                    type="file"
                                                    // required={true}
                                                    onChange={(e) =>
                                                      updateAccreditationImage(
                                                        e,
                                                        i,
                                                        form,
                                                        whichTab
                                                      )
                                                    }
                                                  />
                                                </label>
                                                <div style={{ marginLeft: '12px', marginTop: '5px' }} className="">Add or Edit</div>
                                              </div>
                                            </Form.Item>
                                          </>)
                                          }


                                          <Form.Item
                                            className="w-100"
                                            style={{
                                              display: "flex",
                                              justifyContent: "end",
                                            }}
                                          >
                                            {formChanged ? (
                                              <Button
                                                className="saveBtn greenBtn"
                                                onClick={handleSave}
                                              >
                                                Save
                                              </Button>
                                            ) : (
                                              <Button
                                                className="saveBtn greenBtn"
                                                style={{
                                                  opacity: "0.5",
                                                  pointerEvents: "none",
                                                }}
                                              >
                                                Save
                                              </Button>
                                            )}
                                          </Form.Item>
                                        </Col>
                                        <Col className="gutter-row tabContent" span={8}>
                                          <div>
                                            {form.getFieldValue(whichTab)?.[i]
                                              ? renderMedia(
                                                form.getFieldValue(whichTab)[i]
                                              ) // ✅ form state is always in sync
                                              : null}
                                          </div>
                                        </Col>
                                      </div>
                                    </div>)}
                                </SortableItem>

                              );
                            })}
                          </SortableContext>
                        </DndContext>
                      </>
                    )

                  }}
                </Form.List>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
